function initWithdrawalForm() {
  const form = document.querySelector('form');
  if (!form) return false;

  form.addEventListener('submit', function () {
    const now = new Date();
    const date = now.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const time = now.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });

    const dateField = document.querySelector('input[name="hidden-1"]');
    const timeField = document.querySelector('input[name="hidden-2"]');

    if (dateField) dateField.value = date;
    if (timeField) timeField.value = time;
  });

  return true;
}

const observer = new MutationObserver(function () {
  if (initWithdrawalForm()) {
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

setTimeout(function () {
  observer.disconnect();
}, 10000);